fragment PotentialActivityEntityFragment on ActivityParticipant {
    id
    name
    avatarUrl
    initials
    htmlUrl
    primaryEmailAddress
    primaryPhoneNumber
    type
}
